import React, { forwardRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import moment from "moment-jalaali";
import DatePickerComponent from 'Utils/Helpers/DatePickerComponent';
import { useSetState } from 'Utils/Helpers/Hooks';
import Inputer from 'Utils/Helpers/Inputer';
import GetAppointmentStatus from 'Utils/Helpers/AppointmentStatus';
import { TextShow } from 'Utils/Helpers/TextShow';
import { SetAppointmentsData } from 'Utils/Helpers/HandleApiData';
import { get_byDate, update_payment } from 'http/components/AppointmentService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { enqueueSnackbar } from 'notistack';
import DateCheck from 'Utils/Helpers/DateCheck';
import ActionButton from 'Utils/Helpers/ActionButton';
import SelectComponent from 'Utils/Helpers/SelectComponent';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AppointmentNewPayment({ id }) {
    const dispatch = useDispatch();
    const { appointments, dateSearch, current, pos } = useSelector((state) => ({
        appointments: state.appointments.appointments,
        dateSearch: state.setting.dateSearch,
        current: state.staff.current,
        pos: state.setting.pos,
    }));
    const [data, setData] = useState(null);
    const [show, setShow] = useState(false);
    const [date, setDate] = useState(moment());
    const [payTypes, setPayTypes] = useState(null);
    const [sPos, setSPos] = useState(0);
    const [controls, setControls] = useSetState ({
        price: {
            id: "price",
            type: 'number',
            placeholder: 'مبلغ',
            value: '',
            icon: <icons.Cash/>,
        },
        description: {
          id: "description",
          type: 'text',
          placeholder: 'توضیحات',
          value: '',
          icon: <icons.ChatDots/>,
        },
    });
    const setControlsValue = (name, value) => {
        setControls({ [name]: { value: value } });
    }
    const onSelectChange = (e) => {
        setSPos(e);
    }

    useEffect(() => {
        const app = appointments.find(item => item.id === id);
        if(app) {
            setData(app);
            setDate(moment(app.date, 'jYYYY/jMM/jDD'));
        }
        if(pos) {
            setPayTypes([{id: 0, name: 'نقدی'}, ...pos])
        }
    },[])

    const setShowDialog = () => {
      setShow(true);
    }
    const handleClose= () => {
        setShow(false);
    }

    const onCreatePayment = async () => {
        dispatch(HandleLoading(true));
        const {price, description} = controls;
        const _date = date.locale("fa").format("jYYYY/jMM/jDD")
        if(_date && price.value !== '') {
            if(DateCheck(_date)) {
                const params = {
                    id: id,
                    date: _date,
                    price: price.value,
                    payType: sPos,
                    description: description.value !== '' ? description.value : null,
                };
                const response = await update_payment(params);
                if(response.status) {
                    const response2 = await get_byDate(dateSearch.date);
                    if(response2.status) {
                        await dispatch(SetAppointmentsData(response2.data));
                        enqueueSnackbar('تراکنش با موفقیت ثبت شد', {variant: 'success'});
                        handleClose();
                    } else {
                        dispatch(HandleLoading(false));
                    }
                } else {
                    dispatch(HandleLoading(false));
                }
            } else {
                enqueueSnackbar('تاریخ انتخاب شده گذشته است', {variant: 'warning'});
                dispatch(HandleLoading(false));
            }
        } else {
          enqueueSnackbar('اطلاعات به درستی وارد نشده است', {variant: 'error'});
          dispatch(HandleLoading(false));
        }
    }

    return (
        <>
            <ActionButton
                icon={<icons.CurrencyDollar/>}
                onClick={setShowDialog}
                disabled={!current[1][1]}
                hidden={!current[1][1]}
            />
            {
                show &&
                <Dialog
                    open={show}
                    fullWidth={true}
                    maxWidth={'sm'}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleClose}
                    aria-describedby="alert-dialog-slide-appointment-edit"
                >
                    <DialogTitle>
                        {"وضعیت مالی"}
                        <div className='close-btn' onClick={handleClose}>
                            <icons.X/>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        {
                            data && 
                            <DialogContentText id="alert-dialog-slide-appointment-edit">
                                <div className='appointment-edit mb-2'>
                                    <div className='patient'>
                                        <TextShow
                                            title={"نام بیمار :"}
                                            data={data.name}
                                            className={'no-hide text-muted'}
                                        />
                                        <TextShow
                                            title={"تاریخ نوبت :"}
                                            data={data.date}
                                            className={'no-hide text-muted'}
                                        />
                                        <TextShow
                                            title={"شماره پرونده :"}
                                            data={data.uniCode}
                                            className={'no-hide text-muted'}
                                        />
                                        <TextShow
                                            title={"وضعیت :"}
                                            data={<GetAppointmentStatus id={data.lastStatus}/>}
                                            className={'no-hide text-muted'}
                                        />
                                    </div>
                                    <div className='mb-1'>
                                        <div className='flex-row-center-center my-2'>
                                            <DatePickerComponent
                                                icon={<icons.Calendar3/>}
                                                value={date}
                                                onChange={(e) => setDate(e)}
                                            />
                                        </div>
                                        <div className='mt-1'>
                                            {
                                                (payTypes && payTypes.length > 1) &&
                                                <div className='flex-row-center-center mb-2'>
                                                    <SelectComponent
                                                        name={'pay-type'}
                                                        icon={<icons.Bank/>}
                                                        options={payTypes}
                                                        onChange={onSelectChange}
                                                    />
                                                </div>
                                            }
                                            {
                                                Object.keys(controls).map((key, index) => {
                                                    return (
                                                        <div className={controls[key].type === 'number' && 'mb-2'}>
                                                            <Inputer
                                                                key={`inputer_${controls[key].id}`}
                                                                id={controls[key].id}
                                                                type={controls[key].type}
                                                                placeholder={controls[key].placeholder}
                                                                value={controls[key].value}
                                                                setValue={setControlsValue.bind(this)}
                                                                icon={controls[key].icon}
                                                                className={controls[key].type === 'text' && 'mb-2'}
                                                            />
                                                            {
                                                                controls[key].type === 'number' &&
                                                                <small className='me-3 text-muted'>
                                                                    {`مبلغ وارد شده : ${Number(controls[key].value).toLocaleString()}`}
                                                                </small>
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div>
                                            <CButton
                                                text={'ذخیره تراکنش جدید'}
                                                icon={<icons.Save2/>}
                                                onClick={onCreatePayment}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </DialogContentText>
                        }
                    </DialogContent>
                </Dialog>
            }
        </>
    );
}